document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      mobileMenu.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });

    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        menuToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.hidden = true;
        document.body.classList.remove('menu-open');
      });
    });
  }

  if (header && header.dataset.sticky === 'true') {
    const setHeaderState = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    setHeaderState();
    window.addEventListener('scroll', setHeaderState, { passive: true });
  }

  const revealItems = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealItems.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-smart-contact]').forEach((contactSection) => {
    const typeSelect = contactSection.querySelector('[data-contact-type]');
    const conditionalGroups = contactSection.querySelectorAll('[data-contact-group]');

    if (!typeSelect || !conditionalGroups.length) return;

    const queryValue = new URLSearchParams(window.location.search).get('anfrage');
    const queryMap = {
      heizsysteme: 'Heizsysteme Löschmann',
      immobilienmanagement: 'Immobilienmanagement Löschmann',
      hausmeisterservice: 'Hausmeisterservice',
      allgemein: 'Allgemeine Anfrage'
    };

    if (queryValue && queryMap[queryValue]) {
      typeSelect.value = queryMap[queryValue];
    }

    const updateContactFields = () => {
      const selectedGroup = {
        'Heizsysteme Löschmann': 'heizsysteme',
        'Immobilienmanagement Löschmann': 'immobilienmanagement',
        Hausmeisterservice: 'hausmeisterservice'
      }[typeSelect.value];

      conditionalGroups.forEach((group) => {
        const isActive = group.dataset.contactGroup === selectedGroup;
        group.hidden = !isActive;
        group.querySelectorAll('input, select, textarea').forEach((field) => {
          field.disabled = !isActive;
        });
      });
    };

    updateContactFields();
    typeSelect.addEventListener('change', updateContactFields);
  });
});
